import React from "react";
import { cn } from "@/lib/utils";

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  label?: string;
  icon?: React.ReactNode;
} 

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, label, icon, ...props }, ref) => {
    const hasError = error && error.length > 0;

    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-3 text-brand-500">
              {icon}
            </div>
          )}
          <textarea
            ref={ref}
            className={cn(
              "flex w-full rounded-lg border bg-white px-3 py-2 text-sm placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 resize-none",
              hasError ? "border-red-500" : "border-gray-300",
              icon && "pl-10",
              className
            )}
            {...props}
          />
        </div>
        {hasError && (
          <p className="text-red-500 text-sm mt-1">{error}</p>
        )}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";
